import apiBaseState from "~/constants/apiBaseState";

export const state = () => ({
    checkBalanceState: apiBaseState(),
});
export const mutations = {
    SET_CHECK_BALANCE_STATE(state, payload){
        state.checkBalanceState = payload;
    },
};

export const getters = {
    messageBirdBalanceOk(state) {
        return state.checkBalanceState.data?.above_minimum;
    }
};

export const actions = {
    GET_MESSAGE_BIRD_BALANCE(state, data) {
        const {accountSlug, projectSlug, taskSlug} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/check-balance`;

        return this.$whyApi.get({
            url,
            mutation: "messageBird/SET_CHECK_BALANCE_STATE",
            errorMessage: "Error getting balance",
            notify: this.$notify
        });
    },
};
